import {
  NotificationSearchBackendField,
  SearchFilterFieldMap,
  SearchFilterFieldName,
} from '@components/cockpit/panels/notificationSearch/notificationSearch.types';

export function getBackendField(field: SearchFilterFieldName): NotificationSearchBackendField {
  return SearchFilterFieldMap[field];
}
